import React, { useState, useEffect } from 'react'
import { CoursesData, LiveEducationData, BooksData, HowToJoinData, DayTradeDashData, SimulatorData, StrategiesData, GuidesData, HowToData, TerminologyData, BestOfData, ReviewsData, QuotesData, AdditionalResourcesData, AboutRossData, MemberStoriesData, LinksData, MoreData, OtherSitesData } from './MenuData'
import MenuSection from './MenuSection'
import MemberAccess from './MemberAccess'
import { IconSearch, IconUser, IconChevronRightSmall } from '../icons/ReactIcons'

export default () => {

  const [isActive, setisActive] = useState(false); // Used for mobile burger menu
  const [mobileActive, setMobileActive] = useState({
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
  });
  const [browserWidthMobile, setBrowserWidthMobile] = useState();
  const [browserWidth, setBrowserWidth] = useState(undefined);

  useEffect(() => {
    window.addEventListener("resize", setWindowWidth);
    setWindowWidth();
    return () => {
      window.removeEventListener("resize", setWindowWidth);
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = isActive ? 'hidden' : 'visible';
    return () => (document.body.style.overflow = 'visible')
  }, [isActive]);

  const setWindowWidth = () => {
    setBrowserWidth(window.innerWidth);
    // console.log("bwidth: " + bwidth);
    // console.log("browserWidth: " + browserWidth);
    if (window.innerWidth > 1023) {
      // console.log("Not a mobile width 2...");
      setisActive(false);
      setMobileActive({menu1: false, menu2: false, menu3: false, menu4: false, menu5:false, menu6:false});
    }
    // Get nav bar height
    // let navBar = document.getElementById('topnavbar');
    // let navBarHeight = navBar.current.clientHeight;
    // console.log('navBar height: ' + navBarHeight);
  }

  // const handleResize = () => {
  //   console.log("handleResize...");
  //   console.log("Window width: " + window.innerWidth);
  //   if (window.innerWidth > 1023) {
  //     setBrowserWidthMobile(false);
  //   } else {
  //     setBrowserWidthMobile(true);
  //   }
  // }

  const updateMobileMenu = (menuNumber) => {

    // console.log("updateMobileMenu...")
    // console.log("window.innerWidth: " + window.innerWidth);
    // console.log("browserWidth: " + browserWidth);
    // if (!browserWidthMobile) { return };
    if (browserWidth > 1023) {
      // console.log("Not a mobile width...");
      setisActive(false);
      setMobileActive({menu1: false, menu2: false, menu3: false, menu4: false, menu5:false, menu6:false});
      return
    }

    // if (browserWidthMobile) { return };
    console.log("updateMobileMenu continuing...")

    let menuDisplay = mobileActive;

    switch (menuNumber) {
      case 1:
        menuDisplay.menu1 = !menuDisplay.menu1;
        setMobileActive({...mobileActive, menu1: menuDisplay.menu1});
        break;
      case 2:
        menuDisplay.menu2 = !menuDisplay.menu2;
        setMobileActive({...mobileActive, menu2: menuDisplay.menu2});
        break;
      case 3:
        menuDisplay.menu3 = !menuDisplay.menu3;
        setMobileActive({...mobileActive, menu3: menuDisplay.menu3});
        break;
      case 4:
        menuDisplay.menu4 = !menuDisplay.menu4;
        setMobileActive({...mobileActive, menu4: menuDisplay.menu4});
        break;
      case 5:
        menuDisplay.menu5 = !menuDisplay.menu5;
        setMobileActive({...mobileActive, menu5: menuDisplay.menu5});
        break;
      case 6:
        menuDisplay.menu6 = !menuDisplay.menu6;
        setMobileActive({...mobileActive, menu6: menuDisplay.menu6});
        break;
        default:
        break;
    }
  }

  // If user clicks on top nav button, this will close dropdown on mouse leave
  // const handleMouseLeave = () => {
  //   console.log("handleMouseLeave...");
  //   document.activeElement.blur();
  // }

  const BurgerDash = () => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="stroke-current text-white w-6 h-6">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
      </svg>
    )
  }

  const MenuTitle = (props) => {
    return (
      <div className="text-lg lg:text-sm xl:text-base XXfont-display font-medium lg:leading-tight xl:leading-tight">{props.title}</div>
    )
  }

  return (
    <React.Fragment>
    <nav className='sticky top-0 z-20'>
      <div id='topnavbar' className="top-nav block lg:flex lg:flex-row justify-between items-center w-full bg-black XXsticky XXtop-0 px-0 z-20" 
      role="navigation" 
      aria-label="main navigation"
      >
        <div className="flex items-center justify-between pl-5 py-2 lg:py-0">
          <a className="flex items-center mr-4" href="/">
            <img className="h-9 object-scale-down" src="https://media.warriortrading.com/2020/10/27000845/wt-logo-2020-horiz.png" alt="Warrior Trading logo" />
          </a>

          <button
            className={`navbar-burger block lg:hidden relative w-6 h-6 mr-5 ${ isActive ? "is-active" : "" }`} 
            aria-label="menu" 
            aria-expanded="false" 
            data-target="wt-navbar-2020"
            onClick={() => setisActive(!isActive)}
          >
            <span aria-hidden="true" className={`absolute top-0 left-0 transition transform ${ isActive ? "rotate-45 translate-y-0" : "-translate-y-2" }`}><BurgerDash /></span>
            <span aria-hidden="true" className={`absolute top-0 left-0 ${ isActive ? "hidden" : "" }`}><BurgerDash /></span>
            <span aria-hidden="true" className={`absolute top-0 left-0 transition transform ${ isActive ? "-rotate-45 translate-y-0" : "translate-y-2" }`}><BurgerDash /></span>
          </button>
        </div>

        <div 
          id="wt-navbar-2020" 
          className={`flex flex-col lg:flex lg:flex-row h-wt-nav overflow-y-auto lg:pr-5 lg:h-auto ${ isActive ? "" : "hidden" }`}
        >

          {/***** Day Trading Education *****/}
          <div className="nav-item group block lg:flex order-3">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800"
              onClick={() => updateMobileMenu(1)}
              // onMouseLeave={() => handleMouseLeave()}
            >
              {/* <span className="text-sm xl:text-base">Products</span> */}
              <MenuTitle title="Day Trading Education" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transform transition ${ mobileActive.menu1 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu1 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ CoursesData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ LiveEducationData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ BooksData } />
                  </div>
                  <div className="lg:flex flex-col">
                  <MenuSection menuData={ HowToJoinData } />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** Stock Scanners, Charts, & News *****/}
          <div className="nav-item group block lg:flex order-4">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800" 
              onClick={() => updateMobileMenu(2)}
              // onMouseLeave={() => handleMouseLeave()}
            >
              {/* <span className="text-sm xl:text-base">Day Trading Tools</span> */}
              <MenuTitle title="Tools" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transition transform ${ mobileActive.menu2 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu2 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ DayTradeDashData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ SimulatorData } />
                  </div>
                  <div className="flex flex-col">
                    &nbsp;
                  </div>
                  <div className="flex flex-col">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** Paper Trading Simulator *****/}
          {/* <div className="nav-item group block lg:flex order-5">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800" 
              onClick={() => updateMobileMenu(3)}
            >
              <MenuTitle title="Paper Trading Simulator" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transition transform ${ mobileActive.menu3 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu3 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ SimulatorData } />
                  </div>
                  <div className="flex flex-col">
                    &nbsp;
                  </div>
                  <div className="flex flex-col">
                    &nbsp;
                  </div>
                  <div className="flex flex-col">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/***** Day Trading FAQs *****/}
          <div className="nav-item group block lg:flex order-6">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800" 
              onClick={() => updateMobileMenu(3)}
              // onMouseLeave={() => handleMouseLeave()}
            >
              {/* <span className="text-sm xl:text-base">Success Stories</span> */}
              <MenuTitle title="FAQs" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transition transform ${ mobileActive.menu3 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu3 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ StrategiesData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ GuidesData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ HowToData } />
                  </div>
                  <div className="hidden lg:flex flex-col">
                    <MenuSection menuData={ TerminologyData } />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** Resources *****/}
          <div className="nav-item group block lg:flex order-7">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800" 
              onClick={() => updateMobileMenu(4)}
              // onMouseLeave={() => handleMouseLeave()}
            >
              {/* <span className="text-sm xl:text-base">Resources</span> */}
              <MenuTitle title="Resources" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transition transform ${ mobileActive.menu4 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu4 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ BestOfData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ ReviewsData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ QuotesData } />
                  </div>
                  <div className="flex flex-col">
                    {/* <MenuSection menuData={ BrokerRebatesData } /> */}
                    <MenuSection menuData={ AdditionalResourcesData } />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** About *****/}
          <div className="nav-item group block lg:flex order-8 XXmb-28 lg:mb-0">
            <button 
              className="nav-link w-full flex justify-between text-gray-200 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800" 
              onClick={() => updateMobileMenu(5)}
              // onMouseLeave={() => handleMouseLeave()}
            >
              {/* <span className="text-sm xl:text-base">About</span> */}
              <MenuTitle title="About" />
              <span className="inline-flex items-center justify-center h-6 w-6 icon-arrow lg:hidden">
                <i className={`transition transform ${ mobileActive.menu5 ? "rotate-90" : "" }`}>
                  <IconChevronRightSmall />
                </i>
              </span>
            </button>
            <div className={`nav-dropdown lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 pt-2 pb-8 lg:group-hover:block ${ mobileActive.menu5 ? "block" : "hidden" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-0 lg:gap-6">
                  <div className="flex flex-col">
                    <MenuSection menuData={ AboutRossData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ MemberStoriesData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ LinksData } />
                  </div>
                  <div className="flex flex-col">
                    <MenuSection menuData={ MoreData } />
                    <MenuSection menuData={ OtherSitesData } />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** Join Now *****/}
          <div className="nav-item group block lg:flex order-9 mb-28 lg:mb-0">
            <a 
              className="nav-link w-full flex justify-between text-gray-100 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800 text-center" 
              href="/memberships/" 
              target=""
            >
              <div className='relative p-1 px-2 bg-wt-blue group-hover:bg-wt-orange rounded -top-1 flex items-center justify-center'>
                {/* <div className='absolute w-3 h-3 mr-1 bg-white rounded-full transition-opacity animate-ping left-2'></div> */}
                {/* <div className='relative w-3 h-3 mr-1 bg-white rounded-full'></div> */}
                <MenuTitle title="Join Now" />
              </div>
            </a>
          </div>

          {/***** Demo *****/}
          <div className="nav-item group block lg:flex order-9 mb-28 lg:mb-0">
            <a 
              className="nav-link w-full flex justify-between text-gray-100 mt-px lg:mt-0 px-5 lg:px-3 py-4 lg:py-8 items-start bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800 text-center" 
              href="https://www.warriortrading.com/watch-now/" 
              target="_blank"
            >
              <div className='relative p-1 px-2 bg-red-600 group-hover:bg-wt-orange rounded -top-1 flex items-center justify-center'>
                <div className='absolute w-3 h-3 mr-1 bg-white rounded-full transition-opacity animate-ping left-2'></div>
                <div className='relative w-3 h-3 mr-1 bg-white rounded-full'></div>
                <MenuTitle title="Demo" />
              </div>
            </a>
          </div>

          {/***** Search *****/}
          <div className="nav-item group block lg:flex order-1 lg:order-9">
            <div className="nav-link w-full hidden lg:flex justify-between text-gray-200 px-5 lg:px-3 py-4 lg:py-8 items-center bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800">
              <span className="inline-flex items-center justify-center h-6 w-6">
                {/* <i className="fas fa-lg fa-search"></i> */}
                <div className="text-gray-200 w-6 h-6">
                  <IconSearch />
                </div>
              </span>
            </div>
            <div className={`nav-dropdown block lg:hidden lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darkest2 lg:bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 py-4 lg:py-8 group-hover:block ${ mobileActive.menu1 ? "block" : "" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="flex flex-col items-stretch">
                    <form role='search' action='https://www.warriortrading.com/'>
                      <div className="flex flex-row items-center">
                        <div className="w-full">
                          <input className="w-full rounded-l px-3 py-2" type="text" placeholder="Search..." name="s" id="s" />
                        </div>
                        <div className="">
                          <button type="submit" className="inline-flex items-center justify-center h-10 w-10 bg-wt-blue rounded-r">
                            <span className="icon">
                              {/* <i className="text-gray-200 fas fa-lg fa-search"></i> */}
                              <div className="text-gray-200 w-6 h-6">
                                <IconSearch />
                              </div>
                            </span>
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/***** Member Access *****/}
          <div className="nav-item group block lg:flex order-2 lg:order-10">
            <div className="nav-link w-full hidden lg:flex justify-between text-gray-200 px-5 lg:px-3 py-4 lg:py-8 items-center bg-wt-blue-darkest2 lg:bg-transparent lg:group-hover:bg-gray-800">
              <span className="inline-flex items-center justify-center h-6 w-6">
                <div className="text-gray-200 w-6 h-6">
                  <IconUser />
                </div>
              </span>
            </div>
            <div className={`nav-dropdown block lg:hidden lg:absolute top-full left-0 w-full z-[9999] bg-wt-blue-darkest2 lg:bg-wt-blue-darker lg:border-t-2 lg:border-gray-100 px-5 py-4 lg:pt-2 lg:pb-8 mt-px lg:mt-0 lg:group-hover:block ${ mobileActive.menu1 ? "block" : "" }`}>
              <div className="container m-auto">
                <div className="grid lg:grid-cols-4 gap-2 lg:gap-6">
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="hidden lg:flex flex-col">
                    &nbsp;
                  </div>
                  <div className="flex flex-col">
                    <MemberAccess />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </nav>
    {/* <div className="navbar-spacer h-12 mb-1 lg:h-20 lg:mb-2">
      &nbsp;
    </div> */}
    </React.Fragment>
  )
}